import React, { useEffect, useRef, useState } from 'react';
import { usePurchaseRequestApi } from '../../../../store/api/hooks/purchaseApiHook';
import Layout from '../../../../components/layout';
import Header from '../../../../components/header';
import Drawer from '../../../../components/Drawer';
import Button from '../../../../components/elements/button';
import { Dropdown, Menu } from '../../../../components/Dropdown';
import Pagination from '../../../../components/pagination';
import Search from '../../../../components/search';
import Icon from '../../../../components/icons';
import { AgGridReact } from 'ag-grid-react';
import Loader from '../../../../components/loader';
import { PAGE_SIZE } from '../../../../_common/constant';
import { StatusStaticPRCell, titleCell } from '../../../../components/elements/function';
import { downloadExcel, downloadPDF, showLocalDate } from '../../../../_common/functions';
import toast from 'react-hot-toast';
import Filters from '../../../../components/filters';
import { filterConfigType } from '../../../../_config/types';
import { useDialog } from '../../../../store/api/hooks/dialogHook';
import { useCommonApi } from '../../../../store/api/hooks/commonApiHook';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';
import { useFacilitiesApi } from '../../../../store/api/hooks/facilitiesApiHook';
import { useReceiptApi } from '../../../../store/api/hooks/receiptApiHook';
import { usePurchaseOrderApi } from '../../../../store/api/hooks/purchaseOrderApiHook';
import Currency from '../../../../components/currency';
import ViewReceipt from '../../ReceiveStock/_components/viewReceipt';

type PurchaseHistoryProps = {
  partDetails: any;
};

const PurchaseHistory: React.FC<PurchaseHistoryProps> = ({ partDetails }) => {
  const prAPI = usePurchaseRequestApi();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchParam, setSearchParam] = useState<string>('');
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [gridApi, setGridApi] = useState<any>(null);
  const [gridColumnApi, setGridColumnApi] = useState<any>(null);
  const [rowData, setrowData] = useState<any>(null);
  const [filters, setFilters] = useState<any>({});
  const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false, locationFilter: false });
  const [selectedPRid, setSelectedPRid] = useState<any>(null);
  const [viewMode, setViewMode] = useState<'view' | 'approve'>('view');
  const filtersRef: any = useRef();
  const { confirm } = useDialog();
  const createReceiptRef = useRef<any>(null);
  const viewprRef = useRef<any>(null);
  const commonApi: any = useCommonApi();
  const spearPartsAPI = useSpearPartsApi();
  const facilityApi: any = useFacilitiesApi();
  const receiveStockApi: any = useReceiptApi();
  const prorderAPI: any = usePurchaseOrderApi();

  const [purchaseRequestTypeOptions, setPurchaseRequestTypeOptions] = useState<any[]>([]);
  const [purchaseRequestStatusOptions, setPurchaseRequestStatusOptions] = useState<any[]>([]);
  const [facilityoption, setFacilityoption] = useState<any>([]);
  const [vendorlist, setvendorList] = useState<any>([]);


  const getfacilitylist = () => {
    const payload = {};
    facilityApi.getFacilityList(
      payload,
      (resp: any) => {
        let facilitylist: any = [];
        resp.facilityList.map((facility: any) => {
          facilitylist.push({
            label: facility.facilityName,
            value: facility.facilityID,
            data: facility
          });
        });
        setFacilityoption(facilitylist);
      },
      (error: any) => {
        console.log("error =>", error);
        toast.error(error);
      }
    );
  };


  const columnDefs = [
    {
      headerName: 'Receipt No',
      field: 'receiptCode',
      headerClass: 'bg-[#f0f0f0]',
      width: 280,
      cellRenderer: (data: any) => (
        <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p>
      )
    },
    {
      headerName: 'PO Number', field: 'purchaseOrderCode', headerClass: 'bg-[#f0f0f0]', width: 280,
      cellRenderer: (data: any) => (
        <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p>
      )
    },
    {
      headerName: 'Vendor Name', field: 'vendorName', headerClass: 'bg-[#f0f0f0]', width: 170, cellRenderer: titleCell
    },
    {
      headerName: 'Facility', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 150, cellRenderer: titleCell
    },
    {
      headerName: 'Receiving Value', field: 'receivingAmount', headerClass: 'bg-[#f0f0f0]', width: 150, cellClass: 'ag-right-aligned-cell', cellRenderer: (params: any) => (
        <Currency
          currency="USD"
          value={Number((params.value ?? 0).toFixed(2))}
        />
      )
    },
    {
      headerName: 'Received Qty', field: 'requiredQuantity', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 160, cellRenderer: titleCell
    },
    {
      headerName: 'Received On', field: 'receiptDate', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 160, cellRenderer: (data: any) => (
        <p className='hover:text-primary font-semibold cursor-pointer'>{showLocalDate(data.value)}</p>
      )
    },
    { headerName: 'Received By', field: 'receiptByName', headerClass: 'bg-[#f0f0f0]', width: 230, cellRenderer: titleCell },
    {
      headerName: "Actions",
      field: "actions",
      headerClass: 'bg-[#f0f0f0] text-center',
      width: 90,
      cellRenderer: (params: any) => {
        const statusID = params?.data?.purchaseRequestStatusID;

        return (
          <div className='relative h-full w-full flex items-center justify-center'>
            <Icon name='threedote' size={1.25} className='text-[#000000]' />
            <select
              onChange={(e) => {
                handleActionChange(e, params);
                e.target.selectedIndex = -1;
              }}
              onFocus={(e) => e.target.selectedIndex = -1}
              className="action-dropdown"
              value={''}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                opacity: 0,
                cursor: "pointer",
              }}
            >
              <option value="view">View</option>
            </select>
          </div>
        );
      }
    }
  ];


  const handleActionChange = (e: any, params: any) => {
    const action = e.target.value;
    const rowData = params.data;

    switch (action) {
      case "view":
        setSelectedPRid(rowData.receiptID);
        viewprRef.current?.open();
        break;
      default:
        console.log("Unknown action: ", action);
        break;
    }
    e.target.selectedIndex = -1;
  };

  const onGridReady = (params: any) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  const onRowClicked = (event: any) => {
    if (!event.event.target.closest('input[type="checkbox"]')) {
      event.node.setSelected(false);
    }
  };

  const getSelectedRows = () => {
    const selectedNodes = gridApi?.getSelectedNodes();
    const selectedData = selectedNodes.map((node: any) => node.data);
    return selectedData;
  };

  const GetReceiveStockList = () => {
    const payload: any = {
      partIDs: partDetails.partsID,
      pageSize: PAGE_SIZE,
      pageNumber: currentPage,
      searchParam: searchParam,
    };

    if (filters) {
      Object.keys(filters).map((key: any) => {
        if (filters[key]) {
          payload[key] = filters[key];
        }
      });
    }
    setrowData(null);
    receiveStockApi.GetPurchaseHistoryList(payload, (resp: any) => {
      setrowData(resp.receiptList ? resp.receiptList : []);
      setTotalRecords(resp.totalRecord);

    }, (error: any) => {
      console.log('error =>', error);
      toast.error(error);
    });
  };

  useEffect(() => {
    getfacilitylist();
  }, []);

  useEffect(() => {
    GetReceiveStockList();
  }, [currentPage, searchParam, filters]);

  return (
    <div>

      <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
        <div className='flex items-center gap-2'>
          <h1 className='text-[0.9rem] leading-[1]'>Purchase History of Stock</h1>
          <Drawer _ref={viewprRef} isAfterOpenRender={true} onClose={() => setSelectedPRid(null)}>
            <Drawer.Button> <div style={{ display: 'none' }}></div> </Drawer.Button>
            <Drawer.Content title="View Receive Stock" className='!w-[60rem] !pr-0'>
              <ViewReceipt PrID={selectedPRid} onCreate={() => { viewprRef.current?.close(); setSelectedPRid(null); }} onCancel={() => { setSelectedPRid(null); viewprRef.current?.close(); }} />
            </Drawer.Content>
          </Drawer>
          <Pagination
            perPage={PAGE_SIZE}
            totalRecords={totalRecords}
            onPageChange={setCurrentPage}
            currentPage={currentPage}
          />
        </div>
        <div className='flex items-center gap-2'>
          <Search onSearch={setSearchParam} />
          <Button theme='light' disabled >Export</Button>
        </div>

      </div>
      <div>
        <div className='bg-[#FAFAFA]'>

          <div className="ag-theme-alpine h-1/2">
            <AgGridReact
              columnDefs={columnDefs} // Pass columnDefs
              rowData={rowData || []} // Pass rowData
              pagination={false}
              rowSelection="multiple"
              onGridReady={onGridReady}
              domLayout="autoHeight"
              onRowClicked={onRowClicked}
              noRowsOverlayComponent={() => (
                <div className="flex items-center justify-center h-full">
                  <div className="text-center text-gray-500">
                    <div className="text-lg font-medium">No Data Found</div>
                  </div>
                </div>
              )}
            />
          </div>
        </div>
      </div>

    </div>
  );
};

export default PurchaseHistory;